module.exports = __webpack_public_path__ + "media/images/index-hero-badge-kr-911d91642eda8958cb0a0b00477ccee8.svg";